module.exports = __webpack_public_path__ + "img/TikTokBusiness.3398af0d.svg";